// @flow

import { createLaneActions } from './createLaneActionCreator';

const initialState = {
  laneContents: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  cellPrefixes: {
    isLoading: false,
    isLoaded: false,
    data: []
  },
  cellList: {
    isLoading: false,
    isLoaded: false,
    data: []
  }
};

const createLaneReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createLaneActions.GET_LANE_CONTENTS: {
      return Object.assign({}, state, { laneContents: action.payload });
    }
    case createLaneActions.GET_CELL_PREFIXES: {
      return Object.assign({}, state, { cellPrefixes: action.payload });
    }
    case createLaneActions.GET_CELLS: {
      return Object.assign({}, state, { cellList: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default createLaneReducer;
